import { ISection, Language } from '@/lib/interfaces/interfaces'

// Contenido del bloque de texto (`infoblock`) en el idioma solicitado,
// normalizando los espacios no separables (&nbsp; / \u00a0) a espacios planos.
export const getInfoBlockContent = (section: ISection, language: Language): string => {
  if (!section.infoblock) return ''

  const contentKey = `content_${language}` as keyof typeof section.infoblock
  const content = section.infoblock[contentKey] || ''

  return content.replace(/&nbsp;|\u00a0/gi, ' ')
}
